import { render, staticRenderFns } from "./dmaPopup.vue?vue&type=template&id=50b38523&"
import script from "./dmaPopup.vue?vue&type=script&lang=js&"
export * from "./dmaPopup.vue?vue&type=script&lang=js&"
import style0 from "./dmaPopup.vue?vue&type=style&index=0&id=50b38523&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports